// bluelink.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_BLUELINK_API_KEY,
  authDomain: process.env.REACT_APP_BLUELINK_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_BLUELINK_PROJECT_ID,
  storageBucket: process.env.REACT_APP_BLUELINK_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_BLUELINK_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_BLUELINK_APP_ID,
  measurementId: process.env.REACT_APP_BLUELINK_MEASUREMENT_ID,
};

const app =
  getApps().find((app) => app.name === "BlueLinkApp") ??
  initializeApp(firebaseConfig, "BlueLinkApp");

const db = getFirestore(app);
export { db };
